import type {ShareAccess} from './types'

/**
 * The manual's "Choosing the owner" section (P1-I1). The section does not exist yet; change this
 * one constant when it is published.
 */
export const SHARED_FOLDERS_MANUAL_URL =
  'https://docs.omicsbox.biobam.com/latest/Cloud-Computation-and-Storage/#choosing-the-owner'

/**
 * What owning a shared folder means (D11), word for word. Shown when a folder is about to be shared
 * and in the dialog's "About ownership" section.
 */
export const OWNERSHIP_NOTE = [
  "This folder stays in your storage. Everything in it, including files others add, counts toward your subscription's storage.",
  'Members keep access only while your account and files exist.',
  "For a long-term team folder, create it in the space of the person who should own the data (for example the lab's PI) and share it from there.",
] as const

/** Labels for the access levels (D6). */
export const ACCESS_LABELS: Record<ShareAccess, string> = {
  owner: 'Owner',
  edit: 'Can edit',
  view: 'Can view',
}

/** Font Awesome glyph for a shared folder until the Material Symbols `folder_shared` icon (D1) lands. */
export const SHARED_FOLDER_ICON = 'fas fa-user-group'

/**
 * sessionStorage key that carries an invitation link across sign-in and sign-up. Shared with the
 * subscription `InvitationPage` and read by `AppRoutes`, so one pending invitation wins after login.
 */
export const INVITATION_RETURN_KEY = 'ob_invitation_return'
